// de-dehub-admin is a STAFF super-admin backoffice. Its permission data comes
// from /prt/general/init, which returns the FULL permission catalog as
// `Object.values(PERMISSIONS)` — an array of MODULE-GROUPED objects
// (e.g. { BIL_001: { code, ... }, BIL_002: { ... } }), NOT a flat per-user
// grant list. A naive `p.code === code` therefore never matches (module groups
// have no top-level `code`), which silently hid permission-gated menus.
//
// Two possible shapes:
//   - flat:    [{ code: "BIL_001", ... }, ...]                  (real per-user grants)
//   - grouped: [{ BIL_001: { code }, ... }, { USR_001: {...} }] (the FULL catalog this app gets)
//
// In de-dehub-admin the data is the grouped catalog returned for EVERYONE — it is
// NOT a per-user grant list, so it must NOT be used to gate individual codes
// (doing so wrongly hides items whose code isn't in a stale/older catalog build).
// Therefore: empty OR grouped-catalog => full access (super-admin). Only a flat
// per-user grant list does real per-code matching.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function hasPermissionCode(permissions: any[], code?: string): boolean {
  if (!code) return true;
  if (!Array.isArray(permissions) || permissions.length === 0) return true;
  const isFlatGrantList = permissions.every((p: any) => p && typeof p.code === "string");
  if (!isFlatGrantList) return true; // grouped catalog => super-admin, allow all
  return permissions.some((p: any) => p.code === code);
}
